export const ServiceProviderSymbol = Symbol('ServiceProvider')
export const ServicesManagerSymbol = Symbol('ServicesManager')
